import React , { Component } from 'react';
import Radium from 'radium';

const svgLogo = require('../resources/images/logo.svg');


const style = {
    height: '30px'
}


class RegistryLogo extends Component {

    render() {
        return (
            <img role="presentation" style={[style, this.props.style]} src={svgLogo}  />
        )
    }
}


export default Radium(RegistryLogo);



// WEBPACK FOOTER //
// ./src/components/RegistryLogo.js